// extracted by mini-css-extract-plugin
export var container = "_64-0";
export var infoButton = "_64-1";
export var label = "_64-3";
export var labelExpanded = "_64-4";
export var price = "_64-5";
export var priceExpanded = "_64-6";
export var title = "_64-2";